import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { CustomSpinnerComponent } from '../custom-spinner/custom-spinner.component';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../search-filter.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSimpleTextEditorModule } from 'ngx-simple-text-editor';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { AssessmentSearchPipe } from '../assessment-search-pipe';
import { MultiAssessmentSearchPipe } from '../multidropdown-search-pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { WebViewerComponent } from '../webviewer/webviewer.component';
import { WebviewerPrintComponent } from '../webviewer-print/webviewer-print.component'
import { StageUserDialogComponent } from '../add-training/stage-user/stage-user.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatRadioModule } from '@angular/material/radio';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { SwitchuserComponent } from '../support/switchuser/switchuser.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FolderStuctureComponent } from '../dms-sub-folder/folder-stucture/folder-stucture.component';
import { MatTreeModule } from '@angular/material/tree';
import { FlexibleFieldsSetupComponent } from '../admin/flexible-fields-setup/flexible-fields-setup.component';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { EditorComponent } from '../editor/editor.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { CommonDynamicButtonComponent } from '../business-area/common-dynamic-button/common-dynamic-button.component';
import { DocumentViewerComponent } from '../support/document-viewer/document-viewer.component';
import { DocumentViewerPrinterComponent } from '../support/document-viewer-printer/document-viewer-printer.component';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';

@NgModule({
  declarations: [
    DocumentViewerComponent,
    DocumentViewerPrinterComponent,
    BreadcrumbComponent,
    CustomSpinnerComponent,
    SearchFilterPipe,
    AssessmentSearchPipe,
    MultiAssessmentSearchPipe,
    WebViewerComponent,
    WebviewerPrintComponent,
    StageUserDialogComponent,
    ExcelPdfComponent,
    StaticAuditTrailComponent,
    SwitchuserComponent,
    FolderStuctureComponent,
    FlexibleFieldsSetupComponent,
    DynamicAuditTrailComponent,
    EditorComponent,
    GridReorderComponent,
    CommonDynamicButtonComponent,
    GlobalLoaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    MatDialogModule,
    NgxSimpleTextEditorModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonModule,
    MatTabsModule,
    MatDatepickerModule,
    BsDatepickerModule.forRoot(),
    MatRadioModule,
    MatTooltipModule,
    MatTreeModule,
    MatCheckboxModule,
    CdkDropList,
    CdkDrag,
    DragDropModule,
  ],
  exports: [
    BreadcrumbComponent,
    CustomSpinnerComponent,
    FormsModule,
    SearchFilterPipe,
    NgMultiSelectDropDownModule,
    NgbModule,
    MatDialogModule,
    NgxSimpleTextEditorModule,
    MatSlideToggleModule,
    MatSelectModule,
    AssessmentSearchPipe,
    MultiAssessmentSearchPipe,
    MatButtonModule,
    MatTabsModule,
    MatDatepickerModule,
    BsDatepickerModule,
    WebViewerComponent,
    WebviewerPrintComponent,
    StageUserDialogComponent,
    DocumentViewerComponent,
    DocumentViewerPrinterComponent,
    ExcelPdfComponent,
    MatRadioModule,
    StaticAuditTrailComponent,
    SwitchuserComponent,
    MatTooltipModule,
    FolderStuctureComponent,
    MatTreeModule,
    FlexibleFieldsSetupComponent,
    DynamicAuditTrailComponent,
    EditorComponent,
    CdkDropList,
    CdkDrag,
    DragDropModule,
    GridReorderComponent,
    CommonDynamicButtonComponent,
    GlobalLoaderComponent
  ]
})
export class SharedModule { }
